<template>
  <div id="app">
    <NavBar />
    <b-container fluid>
      <HeaderTitle
        :compared="items.length > 1 ? 2 : 1"
        v-on:add="addition()"
        v-on:reduce="minus()"
      ></HeaderTitle>
      <b-row>
        <b-col v-for="(item, index) in items" :key="index">
          <MainContainer
            :compare="items.length > 1 ? 2 : 1"
            :data="item"
            :index="index"
          ></MainContainer>
        </b-col>
      </b-row>
      <b-row class="mb-5">
        <b-col> </b-col>
        <b-col sm="8" class="bottom-text text-center" style="width: 100%">
         Rewards based on your engagement in Vitality programmes, Discovery products, and monthly qualifying card spend. Credit initiation & service fees apply. Reward percentages effective 1 January 2025. Interest rate information in this tool last updated 21 November 2025. Always see the Discovery Bank app for the latest rates. Limits, terms and conditions apply. Discovery Bank Limited. Registration number 2015/408745/06. An authorised financial services and registered credit provider. FSP number 48657. NCR registration number NCRCP9997. Discovery Vitality (Pty) Limited. Registration number 1999/007736/07       
        </b-col>
        <b-col>
          <b-btn
            variant="primary"
            class="float-right fab fixed-position"
            @click="scrollToTop()"
          >
            <img src="@/assets/images/icons/fab-icon.png" alt="" />
          </b-btn>
        </b-col>
      </b-row>
    </b-container>
    <StartupModel></StartupModel>
    <JoinDiscoveryBankModel></JoinDiscoveryBankModel>
  </div>
</template>

<script>
// @ is an alias to /src
import NavBar from "@/components/Navbar.vue";
import HeaderTitle from "@/components/HeaderTitle.vue";
import MainContainer from "@/components/MainContainer.vue";
import StartupModel from "@/components/StartupModel.vue";
import JoinDiscoveryBankModel from "@/components/JoinDiscoveryBankModel.vue";
export default {
  name: "Home",
  components: {
    NavBar,
    HeaderTitle,
    MainContainer,
    JoinDiscoveryBankModel,
    StartupModel,
  },
  data() {
    return {
      compared: 1,
      items: [
        {
          value: "200",
          activeCardStatus: "Black",
          activeVitalityMoneyStatus: {
            text: "Diamond",
            colour: "c7b2cc",
          },
          activeProductType: "Suite",
          healthMemberActive: "yes",
          driveMemberActive: "yes",
        },
      ],
    };
  },
  methods: {
    addition() {
      this.items.push({
        value: "200",
        activeCardStatus: "Black",
        activeVitalityMoneyStatus: {
          text: "Diamond",
          colour: "c7b2cc",
        },
        activeProductType: "Card Account",
        healthMemberActive: "yes",
        driveMemberActive: "yes",
      });
    },
    minus() {
      this.items.pop();
    },
    scrollToTop() {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0;
    },
  },
};
</script>
<style lang="scss">
.bottom-text {
  font-size: x-small;
  color: #898a8a;
}
.fixed-position {
  margin-bottom: 2em;
  // position: fixed;
  // z-index: -1;
  // bottom: 20px;
  // right: 20px;
}
</style>
